<form>
  <div class="modal-header">
    <h4 class="modal-title">
      {{'outdatedArticlesPopUp.title' | translate}}
    </h4>
  </div>
  <div class="modal-body pt-0">
    <div class="modal-body-inner">
      <div class="row">
        <div class="col-lg-12">
          <p>{{'outdatedArticlesPopup.label.outdatedArticles.loadProjectState' | translate}}</p>
        </div>
        <div class="col-lg-12">
          <p>{{getOutdatedConfigurationLabel()}}</p>
        </div>
      </div>
      <div class="fixed-fluid flex-grow-1">
        <div class="fluid d-flex flex-column overflow-scrolling-touch">
          <table class="table table-striped table-hover flex-grow-0 flex-shrink-0" fixedHeader [virtual]="true">
            <thead>
              <tr class="d-flex w-100">
                <th class="d-block flex-shrink-1 flex-grow-1" #headerArticleNumber>{{'outdatedArticlesPopup.label.ArticleNumber' | translate}}</th>
                <th class="d-block flex-shrink-1 flex-grow-1" #headerStatus>{{'outdatedArticlesPopup.label.outdatedDate' | translate}}</th>
              </tr>
            </thead>
          </table>
          <virtual-scroller #scroll class="flex-grow-1 overflow-xh scroll-maxh-300" [items]="outdatedArticles" [enableUnequalChildrenSizes]="true"
            maxHeightOffset="700">
            <table class="accessory-table table table-hover table-striped table-overflow-hidden fixed-layout">
              <tbody class="new-stacking-context" #container>
                <tr *ngFor="let article of scroll.viewPortItems"
                  [class.active]="selectedArticle && article.articleVO.identity === selectedArticle.identity">
                  <td [attr.width.px]="headerArticleNumber.clientWidth">
                    <strong>{{article.articleNo}}</strong>
                  </td>
                  <td [attr.width.px]="headerStatus.clientWidth">
                    <div>{{getOutdatedArticleLabel(article)}}</div>
                  </td>
                </tr>
              </tbody>
            </table>
          </virtual-scroller>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <p>{{'outdatedArticlesPopup.label.outdatedArticlesFoundMessage.loadProjectState' | translate}}</p>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button id="button-submit" class="btn btn-primary btn-forward" type="submit" (click)="close()">{{'global.label.ok' | translate}}</button>
  </div>
</form>
